import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

let lang = localStorage.lang;

export default {
    state: {
        // 产品说明参数
        mainInstructions:[],
        // 
        // ******** 产品试用说明 ************
        // 
        instr_list: [], // 试用说明列表
        instr_detail: {}, // 试用说明详情
    },
    mutations: {
        // 首页产品试用说明
        setMainInstructions(state, arg){
            for(var item of arg){
                if(item.image.indexOf("http")<0){
                    item.image = URL.imgUrl+item.image
                }
            }
            state.mainInstructions = arg;
        },
        // 
        // ******** 产品试用说明 ************
        // 
        setInstructionsList(state, arg){
            state.instr_list = arg;
        },
        setInstructionsDetail(state, arg){
            state.instr_detail = arg;
        },
    },
    actions: {
        getMainInstructions(context){
            let url = "/index/index/product?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code==1){
                    context.commit("setMainInstructions",res.data.product);
                }
            }).catch(() => {})
        },
        // 
        // ******** 产品试用说明 ************
        // 
        getInstructionsList({ commit }, arg){ // 获取试用说明列表
            commit("handleLoading", true);
            let { search, number = "" } = arg,
            url = "/index/product/product",
            data = qs.stringify({
                lang,
                search,
                number
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setInstructionsList", res.data.product.data);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取试用说明列表接口异常：${err}，请联系管理员`);
            })
        },
        getInstructionsDetail({ commit }, arg){ // 获取试用说明详情
            commit("handleLoading", true);
            let url = "/index/product/detail",
            data = qs.stringify({
                lang,
                id: arg
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setInstructionsDetail", res.data.product)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取试用说明详情接口异常：${err}，请联系管理员`);
            })
        }
    }
}